<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


// homepage reviews text placement on hero banner
if ( $('.template-index').length ) {
  $('#shopify-block-judge_me_reviews_all_reviews_text_kqGVHD').appendTo('#slideshow-wrapper-template--16833444577448__16321237356a896dad .slide-content'); 
}

// place footer first block heading below logo
if ( $('.footer').length ) {
  $('.footer .footer-block__text:nth-child(2) .footer-block__heading').prependTo('.footer .footer-block__text:nth-child(2) .rte>p')
}

// carousel review layout
if ( $('#shopify-block-judge_me_reviews_featured_carousel_pgTcH4').length ) {
  $('#shopify-block-judge_me_reviews_featured_carousel_pgTcH4 .jdgm-carousel-item').each( function() {
    let img_container = $(this).find('.jdgm--shop-review-has-image');
    let new_title = $(this).find('.jdgm-carousel-item__reviewer-name-wrapper');
    $(new_title).appendTo(img_container);
  })
}

// newsletter success or error popup close
if ( $('.newsletter-success-modal').length ) {
  console.log(1);
  let close_btn = $('.newsletter-success-modal .close');
  $(close_btn).on('click', function() {
    $('.newsletter-success-modal').fadeOut();
  })
}

// jdm thumbnails size
if ( $('.template-index').length ) {
  $('.jdgm-widget.jdgm-carousel .jdgm-carousel-item').each( function() {
    let jImg = $(this).find('.jdgm-carousel-item__product-image');
    $(jImg).attr('height','98');
    $(jImg).attr('width','98');
  })
}

// close description tab onload
if ( $('.template-product').length ) {
  let box1 = $('#tab-description');
  let box2 = $(box1).find('.toggle-content');
  let boxTitle = $(box1).find('.toggleLink');
  let btnR = $('.desc-readmore').parent();
  $(box1).removeClass('is-active');
  $(box2).removeClass('is-active');
  $(boxTitle).removeClass('is-open');

  $(btnR).on('click', function() {
    console.log(2)
    $(box2).addClass('is-active');
    $(boxTitle).addClass('is-open');
  })
}



